<div class="card">
  <div class="card-header">
    <h2>
      <strong>ngxWaveSurfer Service </strong><br /><span style="font-weight: 100"
      >providers: [NgxWavesurferService]</span>
    </h2>
  </div>

  <div>
    <div id="waveform" (click)="waveSurfer.playPause()"
      audioURL="https://stormy-waters-13875.herokuapp.com/https://firebasestorage.googleapis.com/v0/b/filesupat.appspot.com/o/users%2FEjeVhcUXjvVQ81016kaoK0qAzt92%2FRWTRTXSUWVYQQtxgwlc%2Fexample.mp3?alt=media&token=2e91521d-dab5-4739-a12b-507e2fb78b2a">
    </div>
    <button
      class="btn btn-dark"
      (click)="waveSurferService.WaveSurfer.playPause()"
    >
      Play
    </button>
    <h4>Usage</h4>
    <div class="usage">
      <ul>
        <li>Inject the ngx-wavesurfer service into your component</li>
        <li>
          Declare the service as a provider within the scope of the component
        </li>
        <li>
          Call the service method "create", passing an object with the parameter
          for "container", and that container's selector ('#waveform', etc..)
        </li>
        <li>The create() method returns a full WaveSurfer instance</li>
      </ul>
    </div>
  </div>

  <h4>Code</h4>
  <a href="https://stackblitz.com/edit/ngx-wavesurfer-service-demo?file=src/app/ngx-wavesurfer-service-demo/ngx-wavesurfer-service-demo.component.ts" target="_blank"><button class="stackblitz"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightning-charge" viewBox="0 0 16 16">
    <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41 4.157 8.5z"/>
  </svg> Edit this on Stackblitz</button></a>
  <pre class="language-javascript">
{{ code }}
</pre>
</div>
